import "primeicons/primeicons.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.css";
import React, { Component } from "react";
import { Calendar } from "primereact/calendar";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { Column } from "primereact/column";
import { withRouter } from "react-router-dom";
import "../styles/projectsList.css";
import { getProjectsList, searchProjectsList } from "../services/uiService";
import { sortFields } from "../services/helper";
import SortableHeader from "./fields/SortableHeader";
import "bootstrap-icons/font/bootstrap-icons.css";
import MapiToolbar from "./toolbar/MapiToolbar";
import * as XLSX from "xlsx-js-style";

export class ProjectsList extends Component {
  constructor(props) {
    super(props);
    const userDataString = sessionStorage.getItem("userData");
    let displayName = "";

    if (userDataString) {
      const userData = JSON.parse(userDataString);
      displayName = userData.user.displayName; 
    }

    this.state = {
      globalFilter: null,
      projects: [],
      filteredProjects: [],
      totalRecords: 0,
      pageNumber: 1,
      pageSize: 5,
      totalPages: 1,
      selectedDate: null,
      dateFilter: null,
      sortField: "projectID",
      isLoading: false,
      isExporting: false,
      filters: {
        name: { value: "", matchMode: "contains" },
        numberOfPlans: { value: "", matchMode: "contains" },
        elipseNumber: { value: "", matchMode: "contains" },
        projectNumber: { value: "", matchMode: "contains" },
        projectName: { value: "", matchMode: "contains" },
        updatedDate: { value: "", matchMode: "equals" },
        endDate: { value: "", matchMode: "equals" },
        updatedBy: { value: "", matchMode: "contains" },
        createdBy: { value: displayName, matchMode: "custom" },
        sortField: null,
        sortOrder: null
      },
    };
    this.debounceTimeout = null;
    this.onDateFilterChange = this.onDateFilterChange.bind(this);
    this.fetchAllProjectsList = this.fetchAllProjectsList.bind(this);
  }

  async fetchAllProjectsList() {
    const { pageNumber, totalPages, pageSize } = this.state;
    if (pageNumber > totalPages) return;
    this.setState({ isLoading: true });
    let result = await getProjectsList(
      this.props.generalEndPoint,
      pageSize,
      pageNumber
    );
    this.setState((prevState) => ({
      projects: [...prevState.projects, ...result.projects],
      totalPages: result.totalPages,
      pageNumber: prevState.pageNumber + 1,
      isLoading: true
    }));
    this.searchEventOnBtn(this.state?.filters)
  }

  async handleFilterChange(event, isPagination) {
    const { pageNumber, totalPages, pageSize } = this.state;
    if (isPagination) {
      const queryString = this.createQueryString(this.state?.filters);
      if (pageNumber > totalPages) return;
      this.setState({ isLoading: true });
      let result = await getProjectsList(
        this.props.generalEndPoint,
        pageSize,
        pageNumber,
        queryString
      );
      this.setState((prevState) => ({
        projects: result.projects,
        totalPages: result.totalPages,
        pageNumber: prevState.pageNumber + 1,
        isLoading: false,
      }));
    } else {
      this.setState({ filters: event.filters, isLoading: true });
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      const queryString = this.createQueryString(event?.filters);
      this.debounceTimeout = setTimeout(async () => {
        let result = await searchProjectsList(
          this.props.generalEndPoint,
          queryString
        );
        this.setState((prevState) => ({
          projects: result.projects,
          totalPages: result.totalPages,
          pageNumber: 2,
          isLoading: false,
        }));
      }, 600);
    }
  }

  createQueryString(dynamicParams) {
  /*let params = new URLSearchParams();
  Object.keys(dynamicParams)?.forEach((key) => {
    const value = dynamicParams[key];
    if (value !== null && value !== undefined && value !== "") {
      params.append(key, value);
    }
  });
  return params.toString();*/

  const params = new URLSearchParams();

  Object.keys(dynamicParams)?.forEach((key) => {
    let rawValue = dynamicParams[key];
    let value = rawValue && typeof rawValue === "object" && "value" in rawValue
      ? rawValue.value
      : rawValue;

    if (value !== null && value !== undefined && value !== "") {
      params.append(key, value);
    }
  });

  return params.toString();



} 

  componentDidMount() {
    localStorage.setItem("routeActive", "listproject-route");
    setTimeout(() => {
      if (this.dt?.container) {
        const scrollableDiv = this.dt.container.querySelector(
          ".p-datatable-scrollable-body"
        );
        if (scrollableDiv) {
          scrollableDiv.addEventListener("scroll", this.handleScroll);
          this.scrollableDiv = scrollableDiv;

          if (this.state.projects?.length < 12) {
            scrollableDiv.style.overflowY = "hidden";
          } else {
            scrollableDiv.style.overflowY = "auto";
          }
        }
      }
    }, 500);
    setTimeout(() => {
      this.setState({ showCalendar: true });
    }, 100);
    this.fetchAllProjectsList();
  }

  componentWillUnmount() {
    if (this.scrollableDiv) {
      this.scrollableDiv.removeEventListener("scroll", this.handleScroll);
    }
  }

  handleScroll = () => {
    if (this.scrollableDiv) {
      const { scrollTop, scrollHeight, clientHeight } = this.scrollableDiv;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 20;
      if (isAtBottom && !this.state.isLoading) {
        this.setState({ isLoading: true }, () => {
          this.handleFilterChange(null, true);
          setTimeout(() => {
            this.setState({ isLoading: false });
          }, 1000);
        });
      }
    }
  };

  renderDateFilter() {
    return (
      <Calendar
        value={this.state.dateFilter}
        onChange={this.onDateFilterChange}
        placeholder=""
        // dateFormat="yy-mm-d"
        dateFormat="dd/mm/yy"
        className="p-column-filter"
        selectionMode="range"
        style={{ width: "100%" }}
      />
    );
  }

  renderProjectNumber() {
    return (
      <InputText
        type="number"
        value={this.state.projectNumber}
        maxLength={8}
        onChange={(e) => {
          if (e.target.value.length <= 8) {
            this.dt.filter(e.target.value, "projectNumber", "custom");
          }
        }}
        className="no-spinner"
        style={{ width: "100px" }}
      />
    );
  }

  renderNoOfPlan() {
    return (
      <InputText
        type="number"
        value={this.state.numberOfPlans}
        maxLength={8}
        onChange={(e) => {
          if (e.target.value.length <= 8) {
            this.dt.filter(e.target.value, "numberOfPlans", "custom");
          }
        }}
        className="no-spinner"
        style={{
          width: "100px",
        }}
      />
    );
  }
  onDateFilterChange(event) {
    const startDate = event.value ? this.formatDate(event.value[0]) : "";
    const endDate = event.value ? this.formatDate(event.value[1]) : "";
    this.setState(
      (prevState) => ({
        dateFilter: event.value,
        filters: {
          ...prevState.filters,
          updatedDate: { value: startDate, matchMode: "custom" },
          endDate: endDate ? endDate : "",
        },
      }),
      () => {
        if (this.dt) {
          this.dt.filter(
            this.state.filters.updatedDate,
            "updatedDate",
            "custom"
          );
          this.dt.filter(
            this.state.filters.endDate ? this.state.filters.endDate : "",
            "endDate",
            "custom"
          );
        }
      }
    );
  }

  formatDate(date) {
    if (typeof date === "string") {
      date = new Date(date);
    }
    if (!(date instanceof Date) || isNaN(date)) {
      return null;
    }
    let month = date.getMonth() + 1;
    let day = date.getDate();
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    return date.getFullYear() + "-" + month + "-" + day;
  }

  searchEventOnBtn(filters) {
    this.handleFilterChange(
      {
        filters: {
          ...this.dt.state.filters,
          updatedDate: filters.updatedDate,
        },
      },
      false
    );
  }



onSort = (e) =>{
  let { field, order } = e.sortField ? e : e;
  field = e.sortField;
  order = e.sortOrder;
  
  // Manual toggle if clicking the same field
  if (this.state.sortField === field) {
    order = this.state.sortOrder === 1 ? -1 : 1;
  } else {
    order = e.sortOrder || 1;
  }
  let sortedData = sortFields (field, order, this.state.projects || []);

  // Update the state with sorted data AND sort parameters
  this.setState({ 
    projects: sortedData,
    sortField: field,
    sortOrder: order
  });
}

handleExport = () => {
  this.setState({ isExporting: true });

  try {
    const projects = this.state.projects || [];

    // Headers in the same order as the table
    const headers = [
      "נוצר על ידי",
      "עודכן על ידי",
      "תאריך עדכון",
      "שם הפרויקט",
      "מספר הפרויקט",
      "מספר אליפסה",
      'כמות תמ"ר בפרויקט'
    ];

    // Data rows in the same order as headers
    const data = [
      headers,
      ...projects.map((project) => [
        project.createdBy || "",
        project.updatedBy || "",
        project.updatedDate || "",
        project.projectName || "",
        project.projectNumber || "",
        project.elipseNumber || "",
        project.numberOfPlans || "",
      ]),
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(data);

    // Center alignment + wrap text for all cells
    if (worksheet["!ref"]) {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let r = range.s.r; r <= range.e.r; r++) {
        for (let c = range.s.c; c <= range.e.c; c++) {
          const cellAddress = XLSX.utils.encode_cell({ r, c });
          const cell = worksheet[cellAddress];
          if (!cell) continue;

          cell.s = cell.s || {};
          cell.s.alignment = {
            horizontal: "center",
            vertical: "center",
          };
        }
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");

    // Set sheet to display right-to-left (for Hebrew)
    workbook.Workbook = { Views: [{ RTL: true }] };

    const fileName = `projects_export_${new Date()
      .toISOString()
      .split("T")[0]}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  } catch (error) {
    console.error("Error exporting projects:", error);
  } finally {
    this.setState({ isExporting: false });
  }
}

  render() {
    const dateFilter = this.renderDateFilter();
    const projectNumberView = this.renderProjectNumber();
    const numberOfPlanView = this.renderNoOfPlan();
    const { projects } = this.state;
    const buttonFilterToCreate = (
      <button
        className="closeButton searchFilterBtnCls"
        onClick={() => this.searchEventOnBtn(this.state?.filters)}
      >
        {/* פרויקט חיפוש */}
        חיפוש
      </button>
    );
    return (
      <>
        <div className="relative -mt-5 pt-10">
          <MapiToolbar
            onExport={this.handleExport}
            onDelete={null}
            isLoading={this.state.isExporting}
          />
          <div id="wellcomeDiv">
            <div className="workAreaPageAnimation main-wrap-loader" style={{ minHeight: 'calc(84vh + 8px)' }}>
              <div id="TamarTitleDiv">
                <p className="Tamar_Title searchTitle">
                  {" "}
                  - רשימת פרויקטים – בחירת פרויקט לפתיחה
                </p>
                <div className="datatable-doc-demo pt-1">
                  {/* <div className="card"> */}
                  <DataTable
                    ref={(el) => (this.dt = el)}
                    value={projects}
                    scrollable={projects?.length > 11 ? true : false}
                    scrollHeight="68vh"
                    loading={this.state.isLoading}
                    onSort = {this.onSort}
                    //sortField={this.state.sortField}
                    //sortOrder={this.state.sortOrder}
                    filters={this.state.filters}
                    //onFilter={(e) => this.handleFilterChange(e, false)}
                    className="p-datatable-projects"
                    globalFilter={this.state.globalFilter}
                    emptyMessage={
                      <div className="custom-empty-message-wrapper">
                        <span className="custom-empty-message">
                          .לא נמצאו פרויקטים
                        </span>
                      </div>
                    }
                  >
                    <Column
                      field="name"
                      header=""
                      filterMatchMode="contains"
                      filter
                      filterElement={buttonFilterToCreate}
                      body={(rowData) => (
                        <i
                          className="pi pi-angle-left"
                          style={{ fontSize: "2rem", cursor: "pointer" }}
                          onClick={() => {
                            this.props.history.push(
                              "/home/project-details/" + rowData?.projectNumber,
                              { data: rowData }
                            );
                          }}
                        ></i>
                      )}
                    />
                    <Column
                      field="numberOfPlans"
                      header={
                        <SortableHeader
                          label='כמות תמ"ר בפרויקט'
                          field="numberOfPlans"
                          sortField={this.state.sortField}
                          sortOrder={this.state.sortOrder}
                          onSort={this.onSort}
                        />}
                      filter
                      sortable
                      filterMatchMode="custom"
                      filterFunction={(value, data, ...reset) => {
                        return true;
                      }}
                      filterElement={numberOfPlanView}
                    />
                    <Column
                      field="elipseNumber"
                      header={
                        <SortableHeader
                          label="מספר אליפסה"
                          field="elipseNumber"
                          sortField={this.state.sortField}
                          sortOrder={this.state.sortOrder}
                          onSort={this.onSort}
                        />}
                      filter
                      sortable
                      filterMatchMode="custom"
                      filterFunction={(value, data) => {
                        return true;
                      }}
                    />
                    <Column
                      field="projectNumber"
                      header={
                        <SortableHeader
                          label="מספר הפרויקט"
                          field="projectNumber"
                          sortField={this.state.sortField}
                          sortOrder={this.state.sortOrder}
                          onSort={this.onSort}
                        />}
                      filter
                      sortable
                      filterMatchMode="custom"
                      filterFunction={(value, data) => {
                        return true;
                      }}
                      filterElement={projectNumberView}
                    />
                    <Column
                      field="projectName"
                    header={
                        <SortableHeader
                          label='שם הפרויקט'
                          field="projectName"
                          sortField={this.state.sortField}
                          sortOrder={this.state.sortOrder}
                          onSort={this.onSort}
                        />}
                      filter
                      sortable
                      filterMatchMode="custom"
                      filterFunction={(value, data) => {
                        return true;
                      }}
                    />
                    <Column
                      field="updatedDate"
                    header={
                        <SortableHeader
                          label="תאריך עדכון"
                          field="updatedDate"
                          sortField={this.state.sortField}
                          sortOrder={this.state.sortOrder}
                          onSort={this.onSort}
                        />}
                      filter
                      filterMatchMode="custom"
                      style={{ width: "15%" }}
                      filterFunction={(value, data) => {
                        return true;
                      }}
                      filterElement={dateFilter}
                      sortable
                    />
                    <Column
                      field="updatedBy"
                      header={
                        <SortableHeader
                          label="עודכן על ידי"
                          field="updatedBy"
                          sortField={this.state.sortField}
                          sortOrder={this.state.sortOrder}
                          onSort={this.onSort}
                        />}
                      filter
                      sortable
                      filterMatchMode="custom"
                      filterFunction={(value, data) => {
                        return true;
                      }}
                    />
                    <Column
                      field="createdBy"
                      header={
                        <SortableHeader
                          label="נוצר על ידי"
                          field="createdBy"
                          sortField={this.state.sortField}
                          sortOrder={this.state.sortOrder}
                          onSort={this.onSort}
                        />}
                      filter
                      sortable
                      filterMatchMode="custom"
                      filterFunction={(value, data) => {
                        return true;
                      }}
                    />
                    <Column
                      field="projectID"
                      header={
                        <SortableHeader
                          label="#"
                          field="projectID"
                          sortField={this.state.sortField}
                          sortOrder={this.state.sortOrder}
                          onSort={this.onSort}
                        />}
                      style={{ width: "4%" }}
                      sortable
                    />
                  </DataTable>
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ProjectsList);
